import { PieceGeometryCache } from './pieceGeometryCache';

type Pieces = Map<string, PieceGeometryCache>;

export class SceneGeometryCache {
  readonly pieces: Pieces;

  constructor() {
    this.pieces = new Map<string, PieceGeometryCache>();
  }

  /**
   * Dispose.
   */
  dispose() {
    const { pieces } = this;
    // dispose pieces
    for (const piece of pieces.values()) {
      piece.dispose();
    }
    pieces.clear();
  }

  /**
   * Removes an existing piece.
   * Prereq: Piece with corresponding ID must exist.
   * @param id Piece ID.
   */
  deletePiece(id: string) {
    const { pieces } = this;
    // dispose piece
    const piece = pieces.get(id);
    piece.dispose();
    // remove item from map
    pieces.delete(id);
  }

  /**
   * Returns an existing piece or creates if not available.
   * @param id defines the piece id.
   * @returns the piece.
   */
  touchPiece(id: string) {
    const { pieces } = this;
    // create piece if not available
    if (!pieces.has(id)) {
      const piece = new PieceGeometryCache();
      pieces.set(id, piece);
    }
    return pieces.get(id);
  }
}
